module.exports = (s) => {
  return {
    // 游戏
    game_ids: {
      type: 'select-tree',
      props: {
        options: [],
        ischeckbox: false,
        'check-on-click-node': true,
        props: {
          value: 'id',
          label: 'name',
          children: 'children',
        },
        'select-props': {
          placeholder: '请选择游戏',
          size: 'mini',
          clearable: true,
          accordion: true,
        },
      },
      on: {
        getValue: async(game_id) => {
          s.table_filter.game_ids.value = game_id;

          // 获取素材标签选项
          s.table_filter.material_label_ids.value = [];
          delete s.material_list_params.material_label_ids;
          s.table_filter.material_label_ids.options = await s.getMaterialLabelSelector({ ...(game_id && { game_id }) });
        },
      },
      value: null,
    },
    // 作者
    author_id: {
      type: 'select',
      props: {
        placeholder: '请选择作者',
        filterable: true,
      },
      options: [],
      value: '',
    },
    // 需求方
    demand_sider_id: {
      type: 'select',
      props: {
        placeholder: '请选择需求方',
        filterable: true,
      },
      options: [],
      value: '',
    },
    // 素材类型
    material_type: {
      type: 'select',
      props: {
        placeholder: '请选择类型',
      },
      on: {
        change: (val) => {
          if (val) {
            s.onMaterialTypeChange(val);
          }
        },
      },
      options: [{
        label: '图片',
        value: 1,
      },
      {
        label: '视频',
        value: 2,
      },
      {
        label: '落地页',
        value: 3,
      },
      {
        label: '组图',
        value: 4,
      }],
      value: '',
    },
    // 素材规格
    material_format_id: {
      type: 'select',
      props: {
        placeholder: '请选择规格',
      },
      options: [],
      value: '',
    },
    // 是否原创
    is_original: {
      type: 'select',
      props: {
        placeholder: '请选择是否原创',
        multiple: false,
      },
      options: [
        {
          label: '原创',
          value: 1,
        },
        {
          label: '非原创',
          value: 0,
        },
      ],
      value: [],
    },
    search_type: {
      type: 'select',
      is_filter: true,
      options: [
        { label: '素材名称', value: 'name' },
        { label: '素材ID', value: 'local_material_ids' },
      ],
      value: 'name',
    },
    // 素材名称
    name: {
      type: 'input',
      hidden: false,
      props: {
        placeholder: '请输入素材名称',
      },
      width: 100,
      value: '',
    },
    // 素材ID
    local_material_ids: {
      type: 'input',
      hidden: true,
      props: {
        placeholder: '请输入素材ID',
      },
      width: 100,
      value: '',
    },
    // 备注，支持模糊查询
    note: {
      type: 'input',
      props: {
        placeholder: '请输入备注',
      },
      width: 100,
      value: '',
    },
    // 素材标签 ID
    material_label_ids: {
      type: 'select',
      isGroup: true,
      props: {
        placeholder: '请选择素材标签',
        multiple: true,
        filterable: true,
        clearable: true,
        collapseTags: true,
      },
      options: [],
      value: [],
    },
  };
};

